import { ListPage } from 'src/app/shared/helpers/list-page.class';
import { GqlCompanyService } from '../../modules/graphql/services/company/company.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IApiAddCompanyInput, IApiCompaniesConnection, IApiCompany, IApiCompanyFilter, IApiCompanyMergeInput, IApiDeleteCompanyResponse, IApiSageClass, IApiUpdateCompanyInput } from '../../modules/graphql/types/types';
import { IGqlBaseOptions } from '../../modules/graphql/interfaces/base.interfaces';

@Injectable()
export class CompanyService {

  constructor(
    private companyService: GqlCompanyService
  ) { }

  public get(filters: IApiCompanyFilter[] = [], options?: IGqlBaseOptions): Observable<IApiCompaniesConnection> {
    return this.companyService.getCompanies(filters, options || new ListPage(-1));
  }

  public getById(id: string): Observable<IApiCompany> {
    return this.companyService.getCompanyById(id);
  }

  public getByIdForMerge(id: string): Observable<IApiCompany> {
    return this.companyService.getByIdForMerge(id);
  }

  public add(input: IApiAddCompanyInput): Observable<IApiCompany> {
    return this.companyService.addCompany(input);
  }

  public update(input: IApiUpdateCompanyInput): Observable<IApiCompany> {
    return this.companyService.updateCompany(input);
  }

  public remove(id: string): Observable<IApiDeleteCompanyResponse> {
    return this.companyService.removeCompany(id);
  }

  public getSageClassesByCompanyId(id: string): Observable<IApiSageClass[]> {
    return this.companyService.getSageClassesByCompanyId(id);
  }

  public createSageClass(id: string): Observable<IApiCompany> {
    return this.companyService.createSageClass(id);
  }

  public mergeCompanies(input: IApiCompanyMergeInput): Observable<boolean> {
    return this.companyService.mergeCompany(input);
  }

}
